import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";
import { StbCustomRenderButtonComponent } from "../smart-table-customs/custom-render-button";
import { Receipt } from "../../models/receipt.model";
import { StbCustomRenderDateComponent } from "../smart-table-customs/custom-render-date";
import { StbCustomRenderIdComponent } from "../smart-table-customs/custom-render-id";
import { StbCustomRenderCheckboxComponent } from "../smart-table-customs/custom-render-checkbox";

@Component({
  selector: "ngx-view-table-receipt-details",
  styleUrls: ["./view-table-receipt-details.component.scss"],
  templateUrl: "./view-table-receipt-details.component.html",
})
export class ViewTableReceiptDetailsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() language?: string = "";
  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isEditing = false;

  strSearch = "";
  uid = "anonymous";

  //ng2-smart-table config
  @Input() source: LocalDataSource = new LocalDataSource();
  // settings: any;
  settings = {
    hideHeader: false,
    noDataMessage: "",
    attr: {
      class: "table table-striped",
    },
    actions: {
      columnTitle: "",
      add: false,
      edit: false,
      delete: false,
    },
    columns: {},
  };

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
          this.settings = {
            hideHeader: false,
            noDataMessage:
              user.language == "en" ? "Empty data" : "Không có dữ liệu",
            attr: {
              class: "table table-striped",
            },
            actions: {
              columnTitle: "",
              add: false,
              edit: false,
              delete: false,
            },
            columns: {
              // issueDate: {
              //   title: user.language == "en" ? "Date" : "Ngày",
              //   filter: false,
              //   type: "custom",
              //   renderComponent: StbCustomRenderDateComponent,
              // },
              // receiptId: {
              //   title: user.language == "en" ? "Receipt Code" : "Số phiếu",
              //   type: "custom",
              //   renderComponent: StbCustomRenderIdComponent,
              // },
              productCode: {
                title: user.language == "en" ? "Product Code" : "Mã hàng",
                type: "string",
              },
              productName: {
                title: user.language == "en" ? "Product Name" : "Tên hàng",
                type: "string",
              },
              productUnitName: {
                title: user.language == "en" ? "Unit" : "ĐVT",
                type: "string",
                filter: false,
              },
              quantity: {
                title: user.language == "en" ? "Quantity" : "SL",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              // price: {
              //   title: user.language == "en" ? "Price" : "Đơn giá",
              //   width: "100px",
              //   filter: false,
              //   type: "custom",
              //   renderComponent: StbCustomRenderNumberComponent,
              // },
              // discountAmount: {
              //   title: user.language == "en" ? "$ discount" : "$ Giảm",
              //   width: "100px",
              //   filter: false,
              //   type: "custom",
              //   renderComponent: StbCustomRenderNumberComponent,
              // },
              amount: {
                title: user.language == "en" ? "Sale Amount" : "Tiền bán",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              costAmount: {
                title: user.language == "en" ? "Cost Amount" : "Tiền mua",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              profit: {
                title: user.language == "en" ? "Profit" : "Lãi gộp",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
            },
          };
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //smart-table events
  selectedItem(event): void {
    const item = event.data;
    this.onSelectedItem.emit(item);
  }
}
